import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './services/api'
import {request} from '@/utils/request'
import {auth} from '@/utils/auth'
import Element from 'element-ui'
import moment from 'moment'
import '@/style/index.less'
import '@/style/element.less'
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission'
import VueSignaturePad from "vue-signature-pad";
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 分页组件
import Pagination from "@/components/Pagination";

import '../font_3494592_66gxtw2vyvo/iconfont.css'

// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'

Vue.config.productionTip = false

Vue.prototype.$http = request
Vue.prototype.$api = api
Vue.prototype.$moment = moment
Vue.prototype.$auth = auth

Vue.use(Element)
Vue.component('FileUpload', FileUpload)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)
Vue.use(VueSignaturePad);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
